var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinkingGlasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_15642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62482 27.0214L9.27482 18.9014L10.8948 19.4314L8.24482 27.5514C14.409 29.5657 -1.60087 24.3335 6.62482 27.0214Z",
    fill: "url(#paint0_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85472 19.8512C11.8147 20.4912 13.9247 19.4211 14.5647 17.4611L17.9947 6.94116C18.1047 6.59116 17.9147 6.22114 17.5747 6.11114L11.7247 4.20117C11.3747 4.09117 11.0047 4.28115 10.8947 4.62115L7.46472 15.1411C6.82472 17.1011 7.89472 19.2112 9.85472 19.8512Z",
    fill: "url(#paint1_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_715_15642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93771 19.7188C11.7022 20.295 13.6018 19.3004 14.178 17.5359L17.5511 7.02928C17.6502 6.71419 17.4791 6.38107 17.173 6.28204L11.9065 4.56255C11.5914 4.46352 11.2583 4.63456 11.1592 4.94065L7.78607 15.4472C7.2099 17.2118 8.17318 19.1426 9.93771 19.7188Z",
    fill: "#C2F0FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.2056 18.7914C11.7756 19.3014 13.4656 18.4413 13.9856 16.8713L15.7056 11.5913C15.8156 11.2413 15.5556 10.8813 15.1856 10.8813L9.98563 10.9713C9.75563 10.9713 9.55563 11.1213 9.48563 11.3413L8.28563 15.0114C7.77563 16.5814 8.63563 18.2714 10.2056 18.7914Z",
    fill: "#FFCB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2056 18.7914C11.7756 19.3014 13.4656 18.4413 13.9856 16.8713L15.7056 11.5913C15.8156 11.2413 15.5556 10.8813 15.1856 10.8813L9.98563 10.9713C9.75563 10.9713 9.55563 11.1213 9.48563 11.3413L8.28563 15.0114C7.77563 16.5814 8.63563 18.2714 10.2056 18.7914Z",
    fill: "url(#paint2_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2056 18.7914C11.7756 19.3014 13.4656 18.4413 13.9856 16.8713L15.7056 11.5913C15.8156 11.2413 15.5556 10.8813 15.1856 10.8813L9.98563 10.9713C9.75563 10.9713 9.55563 11.1213 9.48563 11.3413L8.28563 15.0114C7.77563 16.5814 8.63563 18.2714 10.2056 18.7914Z",
    fill: "url(#paint3_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8755 24.8512L23.2255 16.7312L21.6055 17.2612L24.2555 25.3812C16.4007 27.9479 36.0115 21.539 25.8755 24.8512Z",
    fill: "url(#paint4_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 24.0213L21.7153 26.2113C21.2753 26.3513 21.0354 26.8214 21.1854 27.2614C21.3254 27.7014 21.7953 27.9414 22.2353 27.7914L28.9253 25.6113C29.3653 25.4713 29.6054 25.0013 29.4554 24.5613C29.3254 24.1213 28.8554 23.8813 28.4153 24.0213Z",
    fill: "#C3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 24.0213L21.7153 26.2113C21.2753 26.3513 21.0354 26.8214 21.1854 27.2614C21.3254 27.7014 21.7953 27.9414 22.2353 27.7914L28.9253 25.6113C29.3653 25.4713 29.6054 25.0013 29.4554 24.5613C29.3254 24.1213 28.8554 23.8813 28.4153 24.0213Z",
    fill: "url(#paint5_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 24.0213L21.7153 26.2113C21.2753 26.3513 21.0354 26.8214 21.1854 27.2614C21.3254 27.7014 21.7953 27.9414 22.2353 27.7914L28.9253 25.6113C29.3653 25.4713 29.6054 25.0013 29.4554 24.5613C29.3254 24.1213 28.8554 23.8813 28.4153 24.0213Z",
    fill: "url(#paint6_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 24.0213L21.7153 26.2113C21.2753 26.3513 21.0354 26.8214 21.1854 27.2614C21.3254 27.7014 21.7953 27.9414 22.2353 27.7914L28.9253 25.6113C29.3653 25.4713 29.6054 25.0013 29.4554 24.5613C29.3254 24.1213 28.8554 23.8813 28.4153 24.0213Z",
    fill: "url(#paint7_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4153 24.0213L21.7153 26.2113C21.2753 26.3513 21.0354 26.8214 21.1854 27.2614C21.3254 27.7014 21.7953 27.9414 22.2353 27.7914L28.9253 25.6113C29.3653 25.4713 29.6054 25.0013 29.4554 24.5613C29.3254 24.1213 28.8554 23.8813 28.4153 24.0213Z",
    fill: "url(#paint8_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7928 28.3699L4.08452 26.2053C3.64622 26.06 3.17586 26.2994 3.0387 26.7435C2.89345 27.1818 3.13275 27.6522 3.57692 27.7893L10.2712 29.9562C10.7095 30.1014 11.1799 29.8621 11.317 29.418C11.4703 28.9855 11.2311 28.5152 10.7928 28.3699Z",
    fill: "#C3F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7928 28.3699L4.08452 26.2053C3.64622 26.06 3.17586 26.2994 3.0387 26.7435C2.89345 27.1818 3.13275 27.6522 3.57692 27.7893L10.2712 29.9562C10.7095 30.1014 11.1799 29.8621 11.317 29.418C11.4703 28.9855 11.2311 28.5152 10.7928 28.3699Z",
    fill: "url(#paint9_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7928 28.3699L4.08452 26.2053C3.64622 26.06 3.17586 26.2994 3.0387 26.7435C2.89345 27.1818 3.13275 27.6522 3.57692 27.7893L10.2712 29.9562C10.7095 30.1014 11.1799 29.8621 11.317 29.418C11.4703 28.9855 11.2311 28.5152 10.7928 28.3699Z",
    fill: "url(#paint10_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7928 28.3699L4.08452 26.2053C3.64622 26.06 3.17586 26.2994 3.0387 26.7435C2.89345 27.1818 3.13275 27.6522 3.57692 27.7893L10.2712 29.9562C10.7095 30.1014 11.1799 29.8621 11.317 29.418C11.4703 28.9855 11.2311 28.5152 10.7928 28.3699Z",
    fill: "url(#paint11_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7928 28.3699L4.08452 26.2053C3.64622 26.06 3.17586 26.2994 3.0387 26.7435C2.89345 27.1818 3.13275 27.6522 3.57692 27.7893L10.2712 29.9562C10.7095 30.1014 11.1799 29.8621 11.317 29.418C11.4703 28.9855 11.2311 28.5152 10.7928 28.3699Z",
    fill: "url(#paint12_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2488 14.3355C14.5419 14.4232 14.8415 14.267 14.938 13.9755L17.0632 7.52063C17.1509 7.22752 16.9947 6.92794 16.7032 6.83144C16.4101 6.74374 16.1105 6.89989 16.014 7.19146L13.8888 13.6463C13.8011 13.9394 13.9572 14.239 14.2488 14.3355Z",
    fill: "url(#paint13_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6439 17.6812C20.6839 18.3212 18.5739 17.2513 17.9339 15.2913L14.5039 4.77123C14.3939 4.42123 14.5839 4.05125 14.9239 3.94125L20.7739 2.03124C21.1239 1.92124 21.4939 2.11126 21.6039 2.45126L25.0339 12.9712C25.6739 14.9312 24.6039 17.0412 22.6439 17.6812Z",
    fill: "url(#paint14_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_15642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6085 17.5626C20.8428 18.1392 18.7648 17.0626 18.0148 14.8126L14.8068 4.87685C14.6554 4.42981 14.8068 4.18762 15.2603 4.01766L20.5304 2.297C20.8457 2.1979 21.3171 2.39871 21.4162 2.70501L24.6241 12.6407C25.3273 14.922 24.3742 16.9861 22.6085 17.5626Z",
    fill: "#C8F2FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.2951 16.6214C20.7251 17.1314 19.0351 16.2714 18.5151 14.7014L16.2151 7.6314C16.0051 6.9814 16.7751 6.46139 17.2951 6.90139L18.1251 7.6014C19.2051 8.5114 20.5951 8.96139 22.0051 8.87139C22.5351 8.84139 23.0151 9.16141 23.1751 9.67141L24.2151 12.8514C24.7251 14.4114 23.8651 16.1014 22.2951 16.6214Z",
    fill: "#FFCB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2951 16.6214C20.7251 17.1314 19.0351 16.2714 18.5151 14.7014L16.2151 7.6314C16.0051 6.9814 16.7751 6.46139 17.2951 6.90139L18.1251 7.6014C19.2051 8.5114 20.5951 8.96139 22.0051 8.87139C22.5351 8.84139 23.0151 9.16141 23.1751 9.67141L24.2151 12.8514C24.7251 14.4114 23.8651 16.1014 22.2951 16.6214Z",
    fill: "url(#paint15_linear_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2951 16.6214C20.7251 17.1314 19.0351 16.2714 18.5151 14.7014L16.2151 7.6314C16.0051 6.9814 16.7751 6.46139 17.2951 6.90139L18.1251 7.6014C19.2051 8.5114 20.5951 8.96139 22.0051 8.87139C22.5351 8.84139 23.0151 9.16141 23.1751 9.67141L24.2151 12.8514C24.7251 14.4114 23.8651 16.1014 22.2951 16.6214Z",
    fill: "url(#paint16_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8046 5.79135C18.263 5.79135 18.6346 5.41973 18.6346 4.96133C18.6346 4.50294 18.263 4.13135 17.8046 4.13135C17.3462 4.13135 16.9746 4.50294 16.9746 4.96133C16.9746 5.41973 17.3462 5.79135 17.8046 5.79135Z",
    fill: "url(#paint17_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6342 7.6713C19.9435 7.6713 20.1942 7.42055 20.1942 7.11127C20.1942 6.80199 19.9435 6.55127 19.6342 6.55127C19.3249 6.55127 19.0742 6.80199 19.0742 7.11127C19.0742 7.42055 19.3249 7.6713 19.6342 7.6713Z",
    fill: "url(#paint18_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6347 5.29135C19.8169 5.29135 19.9647 5.14359 19.9647 4.96133C19.9647 4.77908 19.8169 4.63135 19.6347 4.63135C19.4524 4.63135 19.3047 4.77908 19.3047 4.96133C19.3047 5.14359 19.4524 5.29135 19.6347 5.29135Z",
    fill: "url(#paint19_radial_715_15642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7338 10.5469C23.0204 10.4399 23.165 10.1346 23.0659 9.84386L20.8636 3.41494C20.7565 3.12832 20.4512 2.98375 20.1605 3.08283C19.8739 3.18986 19.7293 3.4952 19.8284 3.7859L22.0307 10.2148C22.1378 10.5014 22.4431 10.646 22.7338 10.5469Z",
    fill: "url(#paint20_linear_715_15642)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_715_15642",
    x: 7.11914,
    y: 4.03442,
    width: 10.9609,
    height: 16.3481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15642"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_15642",
    x: 14.25,
    y: 1.77148,
    width: 11.1074,
    height: 16.4446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15642"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15642",
    x1: 7.78134,
    y1: 23.4631,
    x2: 9.35431,
    y2: 23.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128571,
    stopColor: "#CCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388882,
    stopColor: "#C3F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665838,
    stopColor: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CEF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_15642",
    x1: 14.7812,
    y1: 5.12488,
    x2: 10.0312,
    y2: 19.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416426,
    stopColor: "#C1DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_15642",
    x1: 15.0634,
    y1: 16.2501,
    x2: 8.13867,
    y2: 13.9376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981107,
    stopColor: "#FFE4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224793,
    stopColor: "#FFEFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360127,
    stopColor: "#FFE6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669356,
    stopColor: "#FFCB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895984,
    stopColor: "#FFE5A4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5009 19.5626) rotate(-71.5651) scale(5.33634 10.6774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0851294,
    stopColor: "#FFBCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381481,
    stopColor: "#FFCB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850834,
    stopColor: "#FFCB9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_15642",
    x1: 22.8445,
    y1: 21.1874,
    x2: 24.4851,
    y2: 20.6406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C1E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128571,
    stopColor: "#CCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CEF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531429,
    stopColor: "#C3F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788571,
    stopColor: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CEF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E5FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1881 26.5626) rotate(70.0169) scale(0.365772 2.94446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.0006 24.9376) rotate(71.565) scale(0.395285 3.18204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1406 26.6876) rotate(11.8839) scale(1.51751 3.29099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0910921,
    stopColor: "#BDE1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705172,
    stopColor: "#BDE2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7819 25.3126) rotate(-176.698) scale(1.6277 3.52996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28345,
    stopColor: "#BDE1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705172,
    stopColor: "#BDE2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.06983 27.3549) rotate(106.002) scale(0.365772 2.94446)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.91878 28.8677) rotate(107.55) scale(0.395285 3.18204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.1559 27.4999) rotate(-14.0362) scale(1.28847 2.79427)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0910921,
    stopColor: "#BDE1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705172,
    stopColor: "#BDE2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2496 28.8437) rotate(171.755) scale(2.39444 5.19275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28345,
    stopColor: "#BDE1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705172,
    stopColor: "#BDE2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_715_15642",
    x1: 14.3564,
    y1: 14.5206,
    x2: 16.7236,
    y2: 6.98774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760808,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_715_15642",
    x1: 18.3116,
    y1: 2.625,
    x2: 23.1866,
    y2: 17.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDDDF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_715_15642",
    x1: 24.6566,
    y1: 10.9064,
    x2: 17.9379,
    y2: 13.1876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0981107,
    stopColor: "#FFE4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224793,
    stopColor: "#FFEFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360127,
    stopColor: "#FFE6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669356,
    stopColor: "#FFCB91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC999"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0004 17.9376) rotate(-91.4144) scale(5.06404 8.77358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.220571,
    stopColor: "#FFBCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514411,
    stopColor: "#FFCB9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.850834,
    stopColor: "#FFCB9D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2343 4.96136) rotate(180) scale(1.25964 1.25964)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC77B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8433 7.67126) rotate(-99.3833) scale(1.28217 1.2822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.200768,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878382,
    stopColor: "#FAC77B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_715_15642",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8055 4.96136) rotate(180) scale(0.500822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC77B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_715_15642",
    x1: 22.9314,
    y1: 10.6296,
    x2: 20.2712,
    y2: 3.19509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760808,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_15642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinkingGlasses);
export default __webpack_public_path__ + "static/media/ClinkingGlasses.adfb42867629f65759e6f0c1e91f871f.svg";
export { ForwardRef as ReactComponent };